import React from "react";
import config from "devextreme/core/config";
import "devextreme-react/text-area";
import { LoadIndicator } from "devextreme-react/load-indicator";
import Form, {
  GroupItem,
  SimpleItem,
  Label,
  Tab,
  TabPanelOptions,
  ColCountByScreen,
  ButtonItem,
  TabbedItem,
} from "devextreme-react/form";
import service from "./data.js";
import FileUploader from "devextreme-react/file-uploader";
import notify from "devextreme/ui/notify";
import Toolbar, { Item } from "devextreme-react/toolbar";
import TabPanel from "devextreme-react/tab-panel";
import { Button } from "devextreme-react/button";
import "./cssPage.css";
import { ValidationSummary } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import './test-form.scss'

import 'devextreme/dist/css/dx.light.css';
import VerifyPopup from "../../components/verifyPopup/VerifyPopup.jsx"
import TextBox from "devextreme-react/text-box";
import { fetchAgentsOnce } from '../../utils/agentApiCache.js';
import EncryptionUtil from "../../utils/encryptionUtil.js";
import { flatObject, unflattenObject, convertToFlatJSON, groupBy3 } from "../../utils/objectUtils.js";
import { saveDraft, popDraft } from "../form/services/formDataStore.js";
import { removeAllCachedForms, cacheFormsContent } from "../../utils/formCache.js"
import DataSetManager from "../../utils/dataSetManager.js";
import FilterEngine from "../../utils/filterEngine.js";
const XLSX = require('xlsx');
var encrypter = require("json-file-encrypt");
var rtlDir;

const { REACT_APP_SERVER_URL } = process.env;
const { REACT_APP_ENCRYPT_KEY } = process.env;

const encryptionKey = new encrypter.encryptor(REACT_APP_ENCRYPT_KEY); //set encryption key

// App header height + small buffer for scroll offset
const APP_HEADER_HEIGHT = 60;

class App extends React.Component {

  componentDidMount() {
    this.initializeComponent();
    this.loadValuesByTaskId();
    // Register save-draft callback so header.js can trigger it before version switch
    window.__saveFormDraft = () => saveDraft(this.doc);
  }

  componentWillUnmount() {
    delete window.__saveFormDraft;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isFirsTimeLoaded && !this.state.isLoading &&
      (prevState.isFirsTimeLoaded !== this.state.isFirsTimeLoaded ||
        prevState.isLoading !== this.state.isLoading)) {
      // Restore data from version-switch (no taskId = new form, not an existing task)
      const hashSearch = window.location.hash.split("?")[1] || "";
      const taskId = new URLSearchParams(hashSearch).get("t");
      if (!taskId) {
        const draft = popDraft();
        if (draft) {
          Object.entries(draft).forEach(([key, val]) => {
            if (val !== null && val !== undefined) {
              if (typeof val === "object" && !Array.isArray(val)) {
                this.doc[key] = Object.assign({}, this.doc[key], val);
              } else {
                this.doc[key] = val;
              }
            }
          });
          this.setState({ formHasChanged: true });
        }
      }
    }
    if (this.state.isFirsTimeLoaded && !this.state.isLoading &&
      (prevState.isFirsTimeLoaded !== this.state.isFirsTimeLoaded ||
        prevState.isLoading !== this.state.isLoading ||
        this.state.formHasChanged)) {
      if (this.state.formHasChanged) {
        this.setState({ formHasChanged: false });
      }
      this.executeFunctionByUid("RunAfterRender");
    }
    if (this.props.location && prevProps.location &&
      this.props.location.search !== prevProps.location.search) {

      // Parse URL parameters to check what changed
      const prevParams = new URLSearchParams(prevProps.location.search);
      const currentParams = new URLSearchParams(this.props.location.search);

      const prevFormId = prevParams.get('f');
      const currentFormId = currentParams.get('f');
      const prevTaskId = prevParams.get('t');
      const currentTaskId = currentParams.get('t');

      // Reset if the form ID changed
      if (prevFormId !== currentFormId) {
        this.doc = service.getEmployee();
        this.setState({ ...this.getDefaultState(), formHasChanged: true });
        this.initializeComponent();
      }
      // Reset if task ID was removed but form ID stayed the same
      else if (!currentTaskId && prevTaskId) {
        this.doc = service.getEmployee();
        this.setState({ ...this.getDefaultState(), formHasChanged: true });
        this.initializeComponent();
      }
    }
  }

  initializeComponent = () => {
    const fId = this.getParameterFromUrl("f");
    this.setState({ formId: fId });

    this.GetDataFromDB(fId);
    this.loadValuesFromUrl();
    this.loadAgentList();
  };

  findRoleSelectBoxField = () => {
    if (!this.template) return null;

    // Search through all template objects to find the roleSelectBox field
    for (const key in this.template) {
      if (Array.isArray(this.template[key])) {
        const field = this.template[key].find(item => item.Type === "roleSelectBox");
        if (field) return field;
      }
    }
    return null;
  };

  loadAgentList = () => {
    // Find the roleSelectBox field to get its role value
    const roleField = this.findRoleSelectBoxField();
    const role = roleField?.Value || "License"; // Use field value or default to "License"

    fetchAgentsOnce(role, process.env.REACT_APP_SERVER_URL)
      .then((data) => {
        if (data && Array.isArray(data)) {
          this.setState({ agentArrWithId: data });
        } else {
          console.warn("No agent data received or format incorrect");
          this.setState({ agentArrWithId: [] });
        }
      })
      .catch((error) => {
        console.error("Failed to load agent data:", error);
        this.setState({ agentArrWithId: [] });
      });
  };


  constructor(props) {
    super(props);

    this.doc = service.getEmployee();
    this.settings = {};
    this.DataSetManager = DataSetManager;
    this.formElement = React.createRef();
    this.state = this.getDefaultState();


    //this.generateNewPhoneOptions = this.generateNewPhoneOptions.bind(this);
    //this.getPhonesOptions = this.getPhonesOptions.bind(this);
    this.updatePhones = this.updatePhones.bind(this);
    this.visibleFunction = this.visibleFunction.bind(this);
    this.execFunction = this.execFunction.bind(this);
    this.executeFunctionByUid = this.executeFunctionByUid.bind(this);
    this.ExecuteMultipleFunctions = this.ExecuteMultipleFunctions.bind(this);
    this.runFunction = this.runFunction.bind(this);
    this.getField = this.getField.bind(this);
    this.getTabs = this.getTabs.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.onSaveFile = this.onSaveFile.bind(this);
    this.executeFunctionByUid = this.executeFunctionByUid.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.clearField = this.clearField.bind(this);
    this.clearUnvisibleData = this.clearUnvisibleData.bind(this);
    // this.objectByString = this.objectByString.bind(this);
    this.renderItem = this.renderItem.bind(this);
    //  this.updateTemplate = this.updateTemplate.bind(this);
    this.fetchTemplate = this.fetchTemplate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.NextTab = this.NextTab.bind(this);
    this.PrevTab = this.PrevTab.bind(this);
    this.ValidateID = this.ValidateID.bind(this);
    this.ValidatePhones = this.ValidatePhones.bind(this);
    this.ValidateImg = this.ValidateImg.bind(this);
    this.HideNextTab = this.HideNextTab.bind(this);
    this.hidePopUp = this.hidePopUp.bind(this);
    this.copyUrl = this.copyUrl.bind(this);
    this.saveAndReset = this.saveAndReset.bind(this);
    this.deleteAndReset = this.deleteAndReset.bind(this);
    this.createUser = this.createUser.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.GetDataFromDB = this.GetDataFromDB.bind(this);
    this.PostFormToDB = this.PostFormToDB.bind(this);
    this.createTabs = this.createTabs.bind(this);
    this.validateConnection = this.validateConnection.bind(this);
    this.setDefaultsValues = this.setDefaultsValues.bind(this);
    this.onFieldDataChanged = this.onFieldDataChanged.bind(this);

    this.showSendPopup = this.showSendPopup.bind(this);
    this.hideSendPopup = this.hideSendPopup.bind(this);
    this.handleSendingTypeSelection = this.handleSendingTypeSelection.bind(this);
    this.validateAndNotify = this.validateAndNotify.bind(this);
    this.buildDraftPayload = this.buildDraftPayload.bind(this);
    //  this.loadValuesByTaskId = this.loadValuesByTaskId.bind(this);

  }

  getDefaultState() {
    return {
      refreshCounter: 0,
      isHomeAddressVisible: false,
      books: [],
      isFirsTimeLoaded: false,
      isLoading: false,
      formHasChanged: false,
      selectedTabIndex: 0,
      defaultVisible: false,
      isNextTabVisible: true,
      refreshPopupVisible: false,
      ownersNames: [],
      phoneMask: [""],
      dataFromDB: null,
      user: null,
      phonesNumbers: [],
      XLClient: "",
      XLAccount: "",
      numOfVisibleTabs: 0,
      setDefaults: true,
      jsonFile: null,
      isMessagePopupVisible: false,
      popupData: null,
      popupMessage: "",
      popupTitle: "",
      sendPopupVisible: false,
      sendingType: null,
      agentArrWithId: null,
      draftName: "",
      showPopup: false,
      sourceStatus: "",
      formId: null,
      dataSetsLoaded: false
    };
  }



  loadValuesByTaskId() {
    this.setState({ isLoading: true });

    this.taskId = this.getParameterFromUrl("t");

    // Check if taskId is not null or undefined before proceeding
    if (this.taskId) {
      // Disable defaults when loading task data
      this.setState({ setDefaults: false });

      this.getValuesFromTask(this.taskId)
        .then(() => {
          // Set isLoading to false once the task is complete
          this.setState({ isLoading: false });
        })
        .catch((error) => {
          //  console.error('Error fetching task values:', error);
          notify("שגיאה בטעינת הנתונים", "error", 10000);
          // Handle the error appropriately and still set isLoading to false
          this.setState({ isLoading: false });
        });
    } else {
      // Handle the case where taskId is null or undefined
      this.setState({ isLoading: false });
    }
  }

  //--------<< predefined values >>------------
  loadValuesFromUrl() {
    const data = this.getParameterFromUrl("d");

    if (data != null) {
      const json = convertToFlatJSON(data);

      Object.entries(json).forEach(([key, value]) => {
        // Split the key on the dot to separate object name and field name
        const keyParts = key.split(".");
        const objectKey = keyParts[0];  // Could be "akjewefc[4]" or "jsxiowjno"
        const fieldName = keyParts[1];  // Could be "firstName" or "mwxoqmo"

        // Regular expression to find the object name and index (if any)
        const objectMatch = objectKey.match(/^(\w+)(?:\[(\d+)\])?$/);

        if (objectMatch) {
          const objectName = objectMatch[1];  // E.g., "akjewefc" or "jsxiowjno"
          const index = objectMatch[2] ? parseInt(objectMatch[2], 10) : null;  // E.g., 4 or null

          // Convert string values to appropriate types
          let parsedValue = value;
          if (value.toLowerCase() === "true") {
            parsedValue = true;
          } else if (value.toLowerCase() === "false") {
            parsedValue = false;
          } else if (!isNaN(value) && value.trim() !== "") {
            parsedValue = parseFloat(value);  // Convert to number if applicable
          }

          if (index !== null) {
            // Handle the case with an index (array format)

            // Ensure the object array exists in doc
            if (!this.doc[objectName]) {
              this.doc[objectName] = [];
            }

            // Ensure the specific index exists in the array
            if (!this.doc[objectName][index]) {
              this.doc[objectName][index] = {};
            }

            // Assign the parsed value to the appropriate field in the array
            this.doc[objectName][index][fieldName] = parsedValue;
          } else {
            // Handle the case without an index (plain object format)

            // Ensure the object exists in doc
            if (!this.doc[objectName]) {
              this.doc[objectName] = {};
            }

            // Assign the parsed value to the appropriate field in the object
            this.doc[objectName][fieldName] = parsedValue;
          }
        }
      });
    }
  }
  //--------<< predefined values >>------------


  getParameterFromUrl(paramName) {
    const url = window.location.href;

    // Extract the fragment part of the URL
    const fragmentIndex = url.indexOf('#');
    const fragment = url.slice(fragmentIndex + 1);

    // Extract the query parameters part from the fragment
    const queryParamsIndex = fragment.indexOf('?');
    const queryParams = fragment.slice(queryParamsIndex + 1);

    // Parse the query parameters part
    const urlParams = new URLSearchParams(queryParams);

    // Get the value of the parameter by name
    const paramValue = urlParams.get(paramName);

    // Check if paramValue is not null or undefined before returning
    if (paramValue) {
      return paramValue;
    }
  }


  interval = () => {
    setTimeout(() => {
      this.setDefaultsValues();
    }, 3000);
  };

  showSendPopup(e) {
    // Show popup just if ther is task id in url
    const taskId = this.getParameterFromUrl('t');
    if (taskId) {
      // todo -> use it to display this popup on drafts
      // this.setState({ sendPopupVisible: true });

    }
  };

  hideSendPopup() {
    this.setState({ sendPopupVisible: false });
  };

  handleSendingTypeSelection(type, e) {
    this.setState({
      sendingType: type,
      sendPopupVisible: false,
    });
    this.sendForm(e);
  }

  render() {
    const { showPopup, draftName } = this.state;
    config({
      animation: {
        enabled: false
      }
    });
    if (this.state.dataFromDB !== null) {
      config({
        rtlEnabled: this.state.dataFromDB.RtlDir, //set form direction form company settings from server
      });
      // this.fetchTemplate();
      rtlDir = this.state.dataFromDB.RtlDir; //set form direction form company settings from server
    }
    const refreshButtonOptions = {
      icon: "refresh",
      text: "רענן",
      onClick: (e) => {
        this.setState({ refreshPopupVisible: true });
      },
    };
    const apendixButtonOptions = {
      text: "שליחת נספח",
      stylingMode: "outlined",
      onClick: (e) => {
        this.setState({ sendApendixPopupVisible: true });
      },
    };
    const copyUrlButtonOptions = {
      icon: "link",
      text: "העתק קישור",
      id: "copyLink",
      onClick: this.copyUrl,
      onMouseEnter: this.toggleWithAnimation,
      onMouseLeave: this.toggleWithAnimation,
    };

    this.closeButtonOptions = {
      text: "סגור",
      stylingMode: "outlined",
      onClick: this.hidePopUp,
    };

    this.saveAndResetButtonOptions = {
      text: " שמור ורענן ",
      stylingMode: "contained",
      onClick: this.reset,
    };

    this.deleteAndResetButtonOptions = {
      text: "מחק ורענן",
      type: "danger",
      stylingMode: "contained",
      onClick: this.deleteAndReset,
    };


    const submitButtonOptions = {
      text: "שלח",
      icon: "exportselected",
      validationGroup: "ownerGroup",
      elementAttr: {
        class: "sendBtn",
      },
      useSubmitBehavior: true,
      onClick: (e) => {
        // todo : need to uncomment to display popup
        // const taskId = this.getParameterFromUrl('t');
        // if (taskId) {
        //   this.showSendPopup(e)
        // }
        // else {
        //   this.sendForm(e);
        // }
        this.sendForm(e);

      },
    };


    const onTabSelectionChanged = (e) => {
      this.setState({
        ownersNames: this.doc.owner.map((item) =>
          item.firstName != undefined && item.lastName != undefined
            ? (this.state.ownersNames = `${item.firstName} ${item.lastName}  `)
            : false
        ),
      });

      this.setState({
        selectedTabIndex: this.template.tabs
          .map((field) => field.caption)
          .indexOf(e.addedItems[0].title),
      });

      this.HideNextTab();
      this.validateConnection();
      // this.updatePhones();
    };

    // // Template with hint per item
    // const itemTemplate = (itemData) => (
    //   <div title={itemData.hint} style={{ display: "flex", alignItems: "center", gap: 6 }}>
    //     <i className={`dx-icon dx-icon-${itemData.icon}`} />
    //     <span>{itemData.text}</span>
    //   </div>
    // );

    const isSourceTemplate = () => {
      return this.state.sourceStatus == "תבנית"
    }

    // Create an itemTemplate function that will render the items with hints
    const itemTemplate = function (itemData) {
      return (
        `<div title="${itemData.hint}">
      <i class="dx-icon dx-icon-${itemData.icon}"></i>
      <span>${itemData.text}</span>
    </div>`
      );
    };
    const menuItems = [
      {
        id: 1,
        text: "הורד קובץ",
        icon: "download",
        hint: "הורדת קובץ טקסט מוצפן. ניתן לצפות בנתונים לאחר שימוש ב- 'טען קובץ'. \nקבצים מצורפים אינם נשמרים."
      },
      {
        id: 2,
        text: "צור תבנית",
        icon: "doc",
        hint: "יצירת תבנית חדשה על בסיס הנתונים שהזנת.\nקבצים מצורפים אינם נשמרים.",
        visible: !isSourceTemplate()
      },
      {
        id: 3,
        text: "עדכן תבנית",
        icon: "doc",
        hint: "עדכון תבנית נוכחית על בסיס השינויים שביצעת.",
        visible: isSourceTemplate()
      }
    ];


    const handleItemClick = (e) => {
      const { id } = e.itemData;

      switch (id) {
        case 1:
          this.onSaveFile();
          break;
        case 2:
          this.setState({
            showPopup: true,
          });
          break;

        case 3:
          this.onSaveChanges("תבנית");
          break;
        default:
          break;
      }
    };


    ///----------------------------------------MAIN FORM--------------------
    if (this.state.isFirsTimeLoaded && !this.state.isLoading) {

      return (
        <React.Fragment>
          <div id="scroll-anchor" style={{ height: 0, scrollMarginTop: `${APP_HEADER_HEIGHT}px` }}></div>
          <Toolbar
            width={"100%"}
            className="toolbar"
            elementAttr={{ id: "top" }}
          >

            <Item
              locateInMenu="auto"
              location="before"
              widget="dxDropDownButton"
              options={{
                text: "שמור טיוטה",
                icon: "save",
                items: menuItems,
                itemTemplate: itemTemplate,
                splitButton: true,
                onItemClick: handleItemClick,
                stylingMode: "contained",
                hint: "המסמך יישמר ברשימת הטיוטות למילוי בהמשך או ממכשיר אחר,\nקבצים מצורפים אינם נשמרים.",
                onButtonClick: () => this.onSaveChanges("טיוטה"),
                displayExpr: "hint",
                hoverStateEnabled: true,  // Ensure hover state is enabled
                showItemDataTooltip: false,  // Turn off automatic tooltip based on text
              }}
            />

            <Item
              //שלח
              locateInMenu="never"
              location="before"
              widget="dxButton"
              options={submitButtonOptions}
            />

            <Item
              //העלה קובץ
              locateInMenu="auto"
              location="before"
              render={this.renderItem}
              widget="dxButton"
              options={{ icon: "upload" }}
            />

            <Item
              // רענן
              locateInMenu="auto"
              location="before"
              widget="dxButton"
              options={refreshButtonOptions}
            />

            <Item
              //שליחת נספח
              locateInMenu="auto"
              location="before"
              widget="dxButton"
              options={apendixButtonOptions}
            />
            {/* <Item
              locateInMenu="auto"
              location="before"
              widget="dxButton"
              options={copyUrlButtonOptions}
            /> */}

            <Item
              location="center"
              locateInMenu="never"
              render={() => (
                <div className="toolbar-label">
                  <b>טפסים חכמים</b> {this.state.dataFromDB.FormName} <br />
                  {this.doc.docName}
                </div>
              )}
            />
          </Toolbar>

          <Popup
            visible={showPopup}
            onHiding={() => this.setState({ showPopup: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showTitle={true}
            title="הזן שם לתבנית"
            width={350}
            height={200}
          >
            <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 15 }}>
              <TextBox
                value={draftName}
                onValueChanged={(e) => this.setState({ draftName: e.value })}
                placeholder="שם התבנית"
                showClearButton={true}
              />
              <Button
                text="שמור תבנית"
                type="default"
                stylingMode="contained"
                width="100%"
                onClick={() => this.onSaveChanges("תבנית")}

              />
            </div>
          </Popup>
          <Popup
            visible={this.state.refreshPopupVisible}
            showTitle={true}
            title="יציאה"
            showCloseButton={false}
            width={300}
            height={180}
            className="no-animation"
          >
            <p>יציאה מההסכם לא תשמור את הנתונים!</p>
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              options={this.closeButtonOptions}
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="center"
              options={this.saveAndResetButtonOptions}
              visible={false}
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="before"
              options={this.deleteAndResetButtonOptions}
            />
          </Popup>
          <Popup
            visible={this.state.sendApendixPopupVisible}
            showTitle={true}
            title="שליחת נספח"
            onHiding={this.hidePopUp}
            showCloseButton={true}
            closeOnOutsideClick={true}
            width={300}
            height={350}
          >
            <p>
              <b>לשליחת נספח יש לבצע את השלבים הבאים:</b>
            </p>
            <p>1. טען את ההסכם הרצוי</p>
            <p>2. עדכן את השינויים הרצויים</p>
            <p>3. בדף האחרון "נספחים" סמן רק את הנספח שברצונך לשלוח</p>
            <p>4. לחץ "שלח" והנספחים הנבחרים בלבד ישלחו לחתימה</p>
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              render={this.renderItem}
              stylingMode={"contained"}
            />
          </Popup>

          <div
            className={`form-container no-animation ${this.state.dataFromDB.RtlDir ? "rtl" : "ltr"
              }`}
          >
            <form
              id="frm"
              // onSubmit={this.handleSubmit}
              className={
                "class='content-block no-animation dx-card form responsive-paddings'"
              }
              ref={this.formElement}
              method="post"
              action={REACT_APP_SERVER_URL + "docfile1"}
              encType="multipart/form-data"
            >
              <Button
                horizontalAlignment="right"
                text={" הקודם "}
                key={"btnPrevUp"}
                icon={rtlDir == true ? "arrowright" : "arrowleft"}
                type="success"
                onClick={this.PrevTab}
                rtlEnabled={true}
              // style={{
              //   float: rtlDir == true ? "right" : "left",
              // }}
              />
              <Button
                horizontalAlignment="left"
                text="הבא"
                key={"btnNextUp"}
                icon={rtlDir == true ? "arrowleft" : "arrowright"}
                //rtlEnabled={direction}
                type="success"
                visible={this.state.isNextTabVisible}
                style={{
                  float: rtlDir == true ? "left" : "right",
                }}
                onClick={this.NextTab}
              />
              <TabPanel
                deferRendering={false}
                selectedIndex={this.state.selectedTabIndex}
                animationEnabled={false}
                swipeEnabled={false}
                onSelectionChanged={onTabSelectionChanged}
              >

                {this.template.tabs.map((field) => this.createTabs(field))}
              </TabPanel>
              <Button
                horizontalAlignment="right"
                text={" הקודם "}
                key={"btnPrevDown"}
                icon={rtlDir == true ? "arrowright" : "arrowleft"}
                type="success"
                onClick={this.PrevTab}
                //  rtlEnabled={true}
                style={{
                  float: rtlDir == true ? "right" : "left",
                }}
              />
              <Button
                horizontalAlignment="left"
                text="הבא"
                key={"btnNextDown"}
                icon={rtlDir == true ? "arrowleft" : "arrowright"}
                // rtlEnabled={true}
                type="success"
                visible={this.state.isNextTabVisible}
                style={{
                  float: rtlDir == true ? "left" : "right",
                }}
                onClick={this.NextTab}
              />
              <Button
                horizontalAlignment="left"
                text="שלח"
                key={"btnSendDown"}
                icon={"exportselected"}
                validationGroup={"ownerGroup"}
                type="default"
                visible={!this.state.isNextTabVisible}
                style={{
                  float: rtlDir ? "left" : "right",
                }}
                onClick={(e) => {
                  // todo : need to uncomment to display popup
                  // const taskId = this.getParameterFromUrl('t');
                  // if (taskId) {
                  //   this.showSendPopup(e)
                  // }
                  // else {
                  //   this.sendForm(e);
                  // }
                  this.sendForm(e);
                }}
              />
              <ValidationSummary
                id="summary"
                validationGroup="ownerGroup"
              />

            </form>
            {/* -------------------------Load Task---------------------- */}

            <div className="container">
              <Popup
                visible={this.state.sendPopupVisible}
                showTitle={true}
                title="שים לב, מסמך זה כבר נשלח. נא בחר את אופן השליחה"
                onHiding={this.hideSendPopup}
                showCloseButton={true}
                closeOnOutsideClick={true}
                width={400}
                height={350}
                titleRender={() => (
                  <b className="popupTitle">
                    שים לב, מסמך זה כבר נשלח. נא בחר את אופן השליחה
                  </b>
                )}
              >
                <div className="popupContent">
                  <div className="buttonRow">
                    <Button
                      icon="copy"
                      type="default"
                      stylingMode="contained"
                      className="button"
                      onClick={(e) => this.handleSendingTypeSelection('duplicate', e)}
                      validationGroup="ownerGroup"
                    />
                    <span className="text">שימוש במסמך קיים ליצירת מסמך חדש</span>
                  </div>

                  <div className="buttonRow">
                    <Button
                      icon="upload"
                      type="default"
                      stylingMode="contained"
                      className="button"
                      onClick={(e) => this.handleSendingTypeSelection('complete', e)}
                      validationGroup="ownerGroup"
                    />
                    <span className="text">השלמת מסמכים - יצירת מסמך המהווה השלמה למסמך שכבר נשלח</span>
                  </div>

                  <div className="buttonRow">
                    <Button
                      icon="repeat"
                      type="default"
                      stylingMode="contained"
                      className="button"
                      onClick={(e) => this.handleSendingTypeSelection('resend', e)}
                      // disabled={true}
                      validationGroup="ownerGroup"
                    />
                    <span className="text">שליחה חוזרת - ביטול מסמך קודם ושליחה לאחר ביצוע שינויים</span>
                  </div>
                </div>
              </Popup>
              <VerifyPopup
                isMessagePopupVisible={this.state.isMessagePopupVisible}
                setMessagePopupVisibility={this.setMessagePopupVisibility}
                popupMessageContent={this.state.popupMessage}
                customFunction={() => this.deleteOwner(this.state.popupData)}
                title={this.state.popupTitle}
                button1Text={"אשר"}
                button2Text={"בטל"}
              />
            </div>
            <VerifyPopup
              isMessagePopupVisible={this.state.isMessagePopupVisible}
              setMessagePopupVisibility={this.setMessagePopupVisibility}
              popupMessageContent={this.state.popupMessage}
              customFunction={() => this.deleteOwner(this.state.popupData)}
              title={this.state.popupTitle}
              button1Text={"אשר"}
              button2Text={"בטל"}
            />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div>
            <h1>מייד עולים 😎</h1>
          </div>
          <div>
            <LoadIndicator id="large-indicator" height={80} width={80} />
          </div>
        </React.Fragment>
      );
    }
  }

  async getValuesFromTask(taskId) {
    this.setState({
      ownersNames: "",
      phonesNumbers: [],
      sendApendixPopupVisible: false,
    });

    //--> Fetch txt content
    const options = {
      method: 'GET',
      credentials: 'include'  // Use 'include' to send cookies/authentication headers
    };

    const apiUrl = `${REACT_APP_SERVER_URL}GetTxt?taskId=${taskId}`;
    const response = await fetch(apiUrl, options);

    if (!response.ok) {
      throw new Error("Failed to fetch the file content");
    }

    //--> Decrypt

    const res = await response.json(); // Extracts JSON data from the response
    this.setState({ sourceStatus: res.sourceStatus })
    this.setState({ draftName: res.name })
    const decryptedData = encryptionKey.decrypt(res.txtData) ? encryptionKey.decrypt(res.txtData) : res.txtData;
    let filteredData = JSON.parse(decryptedData);

    Object.keys(filteredData).forEach((key) => {
      if (key.includes("fileUploader")) {
        delete filteredData[key];
      }
    });

    //--> Load values to fields

    if (res === false) {
      notify("טעינת הקובץ נכשלה, יש לוודא שמדובר בקובץ שמתאים לטופס", "error", 10000);
    } else {
      this.doc = filteredData;
      this.doc.owner.map((item) =>
        this.setState({
          ownersNames: (this.state.ownersNames += `${item.firstName} ${item.lastName}  `),
        })
      );
    }

  };



  //CREATES THE FIELDS AT RUNTIME ------------------------------------------------------------------------

  createTabs(field) {
    //check if the form is in english or hebrew
    // let par = this.state.dataFromDB.EnglishForm
    //   ? field.engValue.split("|")
    //   : field.Value.split("|");
    // const caption = this.state.dataFromDB.EnglishForm
    //   ? field.engCaption
    //   : field.caption;

    let par = field.Value.split("|");
    if (field.Type == "single") {
      return this.getSimpleTabItems(
        field.caption,
        par[0],
        par[1],
        field.visible
      );
    } else if (field.Type == "array") {
      return this.getArrayTabItems(
        field.caption,
        par[0],
        par[1],
        par[2],
        field
      );
    }
  }

  getTabs = (field, fields, key, values, thisObj, index, title, header) => {
    return (
      <Tab
        title={title + " " + (parseInt(index) + 1)}
        // colCount={1}
        key={"tab" + key}
        rtlEnabled={rtlDir}
      >
        <ColCountByScreen xs={1} sm={1} md={1} lg={2} />
        {/* <TabPanelOptions colCount={1} deferRendering={false} /> */}
        <TabPanelOptions deferRendering={false} />
        {fields.map(function (item) {
          return thisObj.getField(item, key + item._uid, index, title);
        })}
        <ButtonItem
          horizontalAlignment="left"
          colSpan={2}
          style={{
            backgroundColor: "red",
          }}
          buttonOptions={{
            text: "הסר " + title + "✖️",
            type: "danger",
            disabled: values[header].length === 1,
            onClick: (e) => {
              this.setMessagePopupVisibility(true)
              this.setState({
                popupData: { e, index, fields },
                popupTitle: "הסרת " + title,
                popupMessage: "האם להסיר " + title + "?"
              })
            }
          }}
        />
      </Tab>
    );
  };

  getField = (dataForField, key, index, title) => {
    const fieldVisible = dataForField.visible
      ? this.visibleFunction(
        dataForField.visible.replaceAll("[x]", "[" + index + "]")
      )
      : this.visibleFunction(dataForField.visible);

    var opt = {
      dataField: { key },
      key: { key },
      //rtlEnabled: direction,
      items: dataForField.Value.split("|"),

      format: dataForField.mask,

      max: dataForField.maxValue,
      min: dataForField.minValue,

      onValueChanged: (e) => {
        this.execFunction(
          dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
          e
        );
        this.updatePhones();
      },
      //visible: fieldVisible,
      multiline: true,
      validationRules: this.getValidation(dataForField, title),
    };
    if (dataForField._uid) {
      //CHECK STATE TO PREVENT RESET OF DEFAULT VALUES
      if (this.state.setDefaults)
        if (dataForField.defaultValue) {
          //check if the object is array
          if (typeof index === "number") {
            Object.assign(this.doc[dataForField.object][index], {
              [dataForField._uid]: dataForField.defaultValue,
            });
          } else {
            //if not an array
            Object.assign(this.doc[dataForField.object], {
              [dataForField._uid]: dataForField.defaultValue,
            });
          }
        }

      switch (dataForField.Type) {
        case "TextStat":
          return (
            <GroupItem
              key={key}
              colSpan={dataForField.colSpan}
              cssClass={dataForField._uid}
              rtlEnabled={rtlDir}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: fieldVisible
                    ? dataForField.caption.replaceAll("\n", "<br>")
                    : "",
                }}
                id={dataForField._uid}
              />
            </GroupItem>
          );
          break;
        case "Header":
          return (
            <GroupItem
              key={key}
              colSpan={4}
              caption={dataForField.helpText}
              visible={fieldVisible}
              rtlEnabled={rtlDir}
            >
              <h3>{dataForField.caption}</h3>
            </GroupItem>
          );
          break;
        case "Header2":
          return (
            <GroupItem
              key={key}
              colSpan={4}
              caption={dataForField.helpText}
              visible={fieldVisible}
              rtlEnabled={rtlDir}
            >
              <h4>{dataForField.caption}</h4>
            </GroupItem>
          );
          break;
        case "Label":
          return (
            <GroupItem key={key} colSpan={4} rtlEnabled={rtlDir}>
              <SimpleItem visible={fieldVisible} rtlEnabled={rtlDir}>
                <h5>{dataForField.caption}</h5>
              </SimpleItem>
            </GroupItem>
          );
          break;

        case "img":
          const imgOpt = {
            visible: { fieldVisible },
            uploadMode: "useForm",
            minFileSize: 1024,
            // maxFileSize: 4 * 1024 * 1024,
            // invalidMaxFileSizeMessage: "הקובץ חורג ממגבלת הגודל של 4 מגה ביט",
            selectButtonText: dataForField.caption,
            labelText: dataForField.helpText,
            accept: "image/*,application/pdf",
            readyToUploadMessage: "Ready to upload",
            uploadedMessage: "Uploaded"
          };
          return (
            <GroupItem key={key} colSpan={4} rtlEnabled={rtlDir}>
              <SimpleItem
                editorType="dxFileUploader"
                editorOptions={imgOpt}
                colSpan={dataForField.colSpan}
                dataField={"fileUploader" + key}
                key={"fileUploader" + key}
                helpText={dataForField.helpText}
                visible={fieldVisible}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              // disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;


        case "multipleFiles":
          const optMultiple = {
            visible: { fieldVisible },
            uploadMode: "useForm",
            multiple: true,
            minFileSize: 1024,
            // maxFileSize: 4 * 1024 * 1024,
            // invalidMaxFileSizeMessage: "הקובץ חורג ממגבלת הגודל של 4 מגה ביט",
            selectButtonText: dataForField.caption,
            labelText: dataForField.helpText,
            accept: ".pdf,.docx", // File extensions
            readyToUploadMessage: "",
            uploadedMessage: "Uploaded",

          };
          return (
            <GroupItem key={key} colSpan={4} rtlEnabled={rtlDir}>
              <SimpleItem
                editorType="dxFileUploader"
                colSpan={dataForField.colSpan}
                dataField={"fileUploader" + key}
                key={"fileUploader" + key}
                helpText={dataForField.helpText}
                visible={fieldVisible}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
                editorOptions={optMultiple}

              // disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;

        case "dxRadioGroup":
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            // visible={fieldVisible}
            >
              <SimpleItem
                editorType="dxRadioGroup"
                editorOptions={opt}
                colSpan={dataForField.colSpan}
                dataField={key}
                key={key}
                visible={fieldVisible}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              // disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label
                  text={dataForField.caption}
                //rtlEnabled={direction}
                />
              </SimpleItem>
            </GroupItem>
          );

          break;
        case "dxDateBox":
          let opdb = {
            rtlEnabled: false,
            dateSerializationFormat: "yyyy-MM-dd",

            displayFormat: "dd-MM-yyyy",
            useMaskBehavior: true,
            max: dataForField.maxValue,
            min: dataForField.minValue,
            dateOutOfRangeMessage: dataForField.validationMessage,
            pickerType: "rollers",
            type: "date",
            disabled: this.visibleFunction(dataForField.disabledByRep),
            dropDownOptions: {
              height: 320,
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxDateBox"
                editorOptions={opdb}
                helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              // disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
        case "dxSlider":
          var par = dataForField.Value.split("|");
          var oprng = {
            //   rtlEnabled: false,
            min: parseInt(par[0]),
            max: parseInt(par[1]),
            step: parseInt(par[2]),
            visible: true,
            defaultValue: parseInt(par[1]),
            tooltip: {
              enabled: true,
              showMode: "always",
              position: "top",
              format: par[3],
            },
            lable: {
              format: par[3],
              position: "bottom",
              visible: true,
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxSlider"
                editorOptions={oprng}
                //  helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              //  disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} visible={true} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxCheckBox":
          let opCb = {
            text: dataForField.caption,
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            //visible={fieldVisible}
            >
              <SimpleItem
                editorType="dxCheckBox"
                editorOptions={opCb}
                helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              //disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} visible={false} />
              </SimpleItem>
            </GroupItem>
          );

          break;
        case "SelectBoxMulti":
          let op = {
            visible: fieldVisible,
            placeholder: "לחץ לבחירה",
            // height: 35,
            items: dataForField.Value.split("|"),
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxTagBox"
                colSpan={dataForField.colSpan}
                editorOptions={op}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                visible={fieldVisible}
                rtlEnabled={rtlDir}
              //  disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;

        case "CustomRadioBoxGroup":
          // const values = this.getItemArray(dataForField.Value);
          let op1 = {
            items: this.getItemArray(dataForField.Value),
            noDataText: "No data to display",
            displayExpr: "name",
            valueExpr: "id",

            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              //eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxRadioGroup"
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                editorOptions={op1}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              //  disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;

        case "CustomSelectBox":
          let dataItems = dataForField.Value.split("|");
          dataItems = dataItems.map((item) => item.split(":"));
          const values = [];
          dataItems.forEach((element) => {
            values.push({
              id: element[0],
              name: element[1],
            });
          });
          let op2 = {
            placeholder: "לחץ לבחירה",
            visible: true,
            items: values,
            noDataText: "No data to display",
            displayExpr: "name",
            valueExpr: "id",
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              this.updatePhones();
            },
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              visible={fieldVisible}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxSelectBox"
                colSpan={dataForField.colSpan}
                editorOptions={op2}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                rtlEnabled={rtlDir}
              //  disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;
        case "SelecBox":
          const sbOp = {
            placeholder: "לחץ לבחירה",
            visible: fieldVisible,
            items: dataForField.Value.split("|"),
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              //  eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxSelectBox"
                colSpan={dataForField.colSpan}
                editorOptions={sbOp}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                visible={fieldVisible}
                rtlEnabled={rtlDir}
              //  disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxTextArea":
          let opTa = {
            autoResizeEnabled: true,
            minHeight: 20,
            stylingMode: "outlined",
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType={"dxTextArea"}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                helpText={dataForField.helpText}
                editorOptions={opTa}
                rtlEnabled={rtlDir}
                validationRules={this.getValidation(dataForField, title)}
                dataField={key}
                key={key}
                disabled={dataForField.disabledByRep ? this.visibleFunction(dataForField.disabledByRep) : false}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "phone":
          let opPhone = {
            visible: true,
            rtlEnabled: false,
            elementAttr: { class: "phone" },
            mask: this.state.phoneMask[index],
            useMaskedValue: true,
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {

              //replace the previeus value in the new one
              if (e.previousValue != "" && e.previousValue !== null) {
                const previosValueIndex = this.state.phonesNumbers.indexOf(
                  e.previousValue
                );
                this.state.phonesNumbers.splice(previosValueIndex, 1);
                const updatedNumbers = this.state.phonesNumbers;
                updatedNumbers.push(e.value);
                this.setState({
                  phonesNumbers: updatedNumbers,
                });

              } else {
                const updatedNumbers = this.state.phonesNumbers;
                updatedNumbers.push(e.value);
                this.setState({
                  phonesNumbers: updatedNumbers,
                });
              }

              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"), e

              );
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType={"dxTextBox"}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                editorOptions={opPhone}
                rtlEnabled={rtlDir}
                dataField={key}
                key={key}
              // disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;

        //-----------------*********************----------------------**********************------------------------
        case "roleSelectBox":

          const { agentArrWithId } = this.state;
          const sbOp1 = {
            placeholder: "לחץ לבחירה",
            visible: fieldVisible,
            items: agentArrWithId, // Use state instead of a local variable
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(
                dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                e
              );
              this.updatePhones();
              this.doc.chosenAgentId = e.value
            },
            displayExpr: "Name",
            valueExpr: "Aid",
          };

          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan} rtlEnabled={rtlDir}>
              <SimpleItem
                editorType="dxSelectBox"
                colSpan={dataForField.colSpan}
                editorOptions={sbOp1}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                visible={fieldVisible}
                rtlEnabled={rtlDir}
              // showClearButton={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        //-----------------*********************--- DataSet & DROPDOWN_DB ---**********************------------------------
        case "DataSet":
          // DataSet is a hidden field that only loads data - no UI rendering
          return null;

        case "DROPDOWN_DB":
          // Parse config from Value column (JSON)
          let dropdownConfig = {};
          try {
            if (dataForField.Value) {
              dropdownConfig = typeof dataForField.Value === 'string'
                ? JSON.parse(dataForField.Value)
                : dataForField.Value;
            }
          } catch (e) {
            console.error('DROPDOWN_DB: Failed to parse Value JSON:', e);
          }

          // Get data from DataSet
          const dataSetName = dropdownConfig.DataSetName;
          let dropdownData = DataSetManager.getData(dataSetName);
          let dropdownError = null;

          // Check for errors
          if (!dataSetName) {
            dropdownError = "שגיאה: DataSetName לא הוגדר";
            console.error('DROPDOWN_DB: Missing DataSetName in config');
          } else if (!DataSetManager.isLoaded(dataSetName)) {
            dropdownError = `שגיאה: DataSet "${dataSetName}" לא נמצא`;
            console.error(`DROPDOWN_DB: DataSet "${dataSetName}" not found`);
          }

          // Get config values
          const valueField = dropdownConfig.ValueField || "KEY";
          const displayField = dropdownConfig.DisplayField || "Caption";
          const filter = dropdownConfig.Filter;
          const hideIfParentEmpty = dropdownConfig.HideIfParentEmpty !== false; // default true
          const resetFields = dropdownConfig.ResetFields || [];
          const distinct = dropdownConfig.Distinct === true;

          // Apply filter if specified
          if (filter && dropdownData.length > 0) {
            // Check if parent fields have values (for HideIfParentEmpty)
            if (hideIfParentEmpty && !FilterEngine.hasParentValues(filter, this.doc)) {
              return null; // Hide field if parent is empty
            }

            // Apply the filter
            dropdownData = FilterEngine.filterData(dropdownData, filter, this.doc);
          }

          // Apply Distinct - show only unique values
          if (distinct && dropdownData.length > 0) {
            const seen = new Set();
            dropdownData = dropdownData.filter(item => {
              const val = item[valueField];
              if (seen.has(val)) return false;
              seen.add(val);
              return true;
            });
          }

          const dropdownDbOpt = {
            placeholder: dropdownError || "לחץ לבחירה",
            visible: fieldVisible,
            disabled: !!dropdownError,
            dataSource: {
              store: dropdownError ? [] : dropdownData,
              paginate: true,
              pageSize: 20,
            },
            valueExpr: valueField,
            displayExpr: displayField,
            searchEnabled: !dropdownError,
            searchExpr: displayField,
            dropDownOptions: {
              animation: null, // Disable dropdown animation
            },
            onValueChanged: (e) => {
              // Handle ResetFields - clear child fields when parent changes
              if (resetFields && Array.isArray(resetFields)) {
                const form = this.formElement.current?.instance;
                resetFields.forEach(fieldUid => {
                  // Build the full field path
                  const fieldPath = typeof index === "number"
                    ? `${dataForField.object}[${index}].${fieldUid}`
                    : `${dataForField.object}.${fieldUid}`;

                  // Clear in this.doc
                  if (typeof index === "number" && this.doc[dataForField.object]?.[index]) {
                    this.doc[dataForField.object][index][fieldUid] = null;
                  } else if (this.doc[dataForField.object]) {
                    this.doc[dataForField.object][fieldUid] = null;
                  }

                  // Also clear via form API if available
                  if (form) {
                    try {
                      form.updateData(fieldPath, null);
                    } catch (err) {
                      console.warn('Could not update form data:', err);
                    }
                  }
                });
              }

              // Execute onChange function if defined
              if (dataForField.onChangeValue) {
                this.execFunction(
                  dataForField.onChangeValue.replaceAll("[x]", "[" + index + "]"),
                  e
                );
              }

              // Trigger re-render for dependent fields
              // Known issue: This causes scroll jump to top
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType="dxSelectBox"
                colSpan={dataForField.colSpan}
                editorOptions={dropdownDbOpt}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
                visible={fieldVisible}
                rtlEnabled={rtlDir}
              >
                <Label text={dataForField.caption || dataForField.Caption} />
              </SimpleItem>
            </GroupItem>
          );

        //-----------------*********************----------------------**********************------------------------
        default:
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={rtlDir}
            >
              <SimpleItem
                editorType={dataForField.Type}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                editorOptions={opt}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                dataField={key}
                key={key}
                rtlEnabled={rtlDir}
              //disabled={this.visibleFunction(dataForField.disabledByRep)}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
          break;
      }

      return (
        <SimpleItem editorType="dxTextBox" dataField={key} key={key}>
          <Label text={dataForField.caption} />
        </SimpleItem>
      );
    } else {
      return (
        <GroupItem
          caption={dataForField.caption}
          key={"rwsr" + Math.floor(Math.random() * 20000)}
          rtlEnabled={rtlDir}
        >
          <p>{dataForField.caption}</p>
        </GroupItem>
      );
    }
  };

  //group, owner,"בעלי חשבון",'הוסף בעל חשבון',this.addOwner
  getArrayTabItems(title, keyHeader, iconName, addButtonTitle, field) {
    const fieldVisible = this.visibleFunction(
      field.visible.replaceAll(
        "[x]",
        "[" + (this.doc[keyHeader].length - 1) + "]"
      )
    );

    return (
      <Item
        title={title}
        key={keyHeader + "item"}
        badge={this.doc[keyHeader].length}
        icon={iconName}
        visible={fieldVisible}
      >
        <Form
          className={"class='content-block dx-card responsive-paddings'"}
          showValidationSummary={false}
          method="post"
          action={REACT_APP_SERVER_URL + "docfile1"}
          colCount={1}
          id="form"
          formData={this.doc}
          validationGroup="ownerGroup"
          onFieldDataChanged={this.onFieldDataChanged}
        >
          <ButtonItem
            horizontalAlignment="right"
            buttonOptions={{
              text: addButtonTitle,
              type: "success",
              onClick: (e) => {
                this.doc[keyHeader].push({});
                this.updatePhones();
              },
              disabled: this.doc[keyHeader].length >= field.maxValue,
            }}
          />
          <TabbedItem colCount={1} key={"tabAlltabGroup"}>
            <TabPanelOptions deferRendering={false} swipeEnabled={false} />
            <ColCountByScreen xs={1} sm={2} md={3} />
            {this.doc[keyHeader].map((item, i) =>
              this.getTabs(
                item,
                this.template[keyHeader],
                keyHeader + "[" + i + "].",
                this.doc,
                this,
                i,
                title,
                keyHeader
              )
            )}
          </TabbedItem>
        </Form>
      </Item>
    );
  }

  getSimpleTabItems(title, keyHeader, iconName, visible) {
    const fieldVisible = this.visibleFunction(visible);
    return (
      <Item
        title={title}
        key={keyHeader + "simpleItem"}
        icon={iconName}
        visible={fieldVisible}
      //rtlEnabled={direction}
      >
        <Form
          className={"class='content-block dx-card responsive-paddings'"}
          showValidationSummary={false}
          method="post"
          action={REACT_APP_SERVER_URL + "docfile1"}
          colCount={1}
          id="form"
          formData={this.doc}
          validationGroup="ownerGroup"
        // rtlEnabled={direction}
        >
          <ColCountByScreen xs={1} sm={1} md={1} lg={2} />
          {this.template[keyHeader].map((field) =>
            this.getField(field, keyHeader + "." + field._uid, "", title)
          )}
        </Form>
      </Item>
    );
  }


  visibleFunction(obj, i) {
    try {
      let ans = eval(obj);
      if (ans === false) {
        return false;
      } else {
        return true;
      }
    } catch {
      return false;
    }
  }

  setMessagePopupVisibility = (isVisible) => {
    this.setState({ isMessagePopupVisible: isVisible });
  }

  execFunction(obj, i) {
    try {
      let ans = eval(obj);
      return ans
    } catch (err) {
      console.error('execFunction error:', err, 'expr:', obj);
      return false;
    }
  }

  createUser() {
    const userData = this.state.user;
    const user = {
      avatarUrl: userData.avatarUrl,
      phone: userData.phone,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      UserWrikeId: userData.UserWrikeId,
    };
    return user;
  }

  hidePopUp() {
    this.setState({
      refreshPopupVisible: false,
      sendApendixPopupVisible: false,
    });
  }

  //get the url from origin
  async copyUrl() {
    const copyText =
      window.location.origin +
      `/#/client-login?u=${this.state.dataFromDB.UrlToApi.substring(35)}&i=${this.state.user.phone
      }`;
    notify(
      {
        message: "העתקת את הקישור ללקוח",
        position: {
          my: "center top",
          at: "center top",
        },
      },
      "info",
      3000
    );
    return await navigator.clipboard.writeText(copyText);
  }

  //save the doc and refresh the page
  saveAndReset() {
    this.onSaveFile();
    window.location.reload();
    this.setState({ refreshPopupVisible: false });
  }

  deleteAndReset() {
    removeAllCachedForms();
    window.location.reload(); // Now it's safe to reload
    this.setState({ refreshPopupVisible: false });
  }

  updatePhones() {
    this.setState({
      refreshCounter: this.state.refreshCounter + 1,
      numOfVisibleTabs: this.countVisibleTabs(this.template.tabs)
    });
    this.HideNextTab();
  }

  HideNextTab() {
    if (this.state.selectedTabIndex === this.state.numOfVisibleTabs - 1) {
      this.setState({ isNextTabVisible: false });
    } else {
      this.setState({ isNextTabVisible: true });
    }
  }

  NextTab() {
    this.executeFunctionByUid("NextTab");
    const anchor = document.getElementById("scroll-anchor");
    if (anchor) anchor.scrollIntoView();
    this.setState({
      selectedTabIndex: this.state.selectedTabIndex + 1,
    });
    this.HideNextTab();
    this.validateConnection();
  }

  PrevTab() {
    const anchor = document.getElementById("scroll-anchor");
    if (anchor) anchor.scrollIntoView();
    this.setState({
      selectedTabIndex: this.state.selectedTabIndex - 1,
    });
    this.HideNextTab();
  }

  //todo: why not every few seconds?
  validateConnection() {
    if (!navigator.onLine) {
      this.onSaveFile();
      notify("משהו השתבש.. אנא בדוק חיבור לאינטרנט", "error", 5000);
    }
  }

  setDefaultsValues() {
    //CHANGE STATE TO PREVENT RESET OF DEFAULT VALUES
    this.setState({ setDefaults: false });
  }

  onFieldDataChanged(e) {
    if (e.dataField.includes("copyDetails")) {
      e.component.repaint();
    }
  }

  downloadFile = async (myData) => {
    let date = new Date();
    date = date.toString().slice(0, -19);
    // if there is name of owner- set is name as file name. if not than set the form name

    const fileName = myData.docName
      ? `${myData.docName} || ${date}`
      : myData.owner && myData.owner[0] && (myData.owner[0].firstName || myData.owner[0].lastName)
        ? `${myData.owner[0].firstName} ${myData.owner[0].lastName} || ${date}`
        : `${this.state.dataFromDB.FormName} || ${date}`;
    const json = JSON.stringify(myData);

    // const key = new encrypter.encryptor(REACT_APP_ENCRYPT_KEY); //set encryption key
    const encryptedJson = encryptionKey.encrypt(json); //returns encrypted string

    const blob = new Blob([encryptedJson], { type: "text/plain" });
    const href = await URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = `${fileName}_encrypted.txt`;  // Ensures .txt extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.setState({ jsonFile: blob });
  };
  onSaveFile = (e) => {
    this.clearUnvisibleData();
    this.executeFunctionByUid("RunBeforeSaveFile");
    this.downloadFile(this.doc);
  }


  buildDraftPayload = (status) => {
    const taskId = this.getParameterFromUrl("t");

    const encryptedJson = encryptionKey.encrypt(JSON.stringify(this.doc)); //returns encrypted string
    const shortName = this.doc.docName ? this.doc.docName : `${this.doc.owner[0].firstName} ${this.doc.owner[0].lastName}`;
    const newTaskName = `${this.state.dataFromDB.FormName}- ${shortName}`;

    const formId = this.getParameterFromUrl("f");
    const sendInput = {
      taskId: taskId == null ? "" : taskId,
      newTxtContent: encryptedJson,
      formId: formId,
      taskName: newTaskName,
      status: status,
    };

    if (status == "תבנית") {
      sendInput.taskName = this.state.draftName
    }
    return sendInput;
  }

  onSaveChanges = async (status) => {

    if (status == "תבנית" && this.state.draftName == "") {
      return;
    }
    this.setState({ showPopup: false })
    notify(
      {
        message: "בתהליך שמירת נתונים",
      },
      "warning",
      3000
    );

    this.downloadFile(this.doc);
    const formId = this.getParameterFromUrl("f");
    const jsonString = JSON.stringify(this.buildDraftPayload(status));

    try {
      //show saving indicator
      const response = await fetch(`${REACT_APP_SERVER_URL}SaveChanges`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: jsonString,
        credentials: "include",
      });

      if (response.ok == true) {
        const responseData = await response.json();
        if (!((responseData.id).includes('!'))) {
          window.location.href = "/#/test-form?f=" + formId + "&t=" + responseData.id;
          this.setState({ sourceStatus: responseData.status })
          this.setState({ isLoading: false });

          notify(
            {
              message: "השינויים נשמרו בהצלחה",
            },
            "success",
            3000
          );
        }
      }
      else {
        notify({ message: "חלה תקלה בשמירת הנתונים", }, "error", 3000);
      }
    } catch (error) {
      notify({ message: "חלה תקלה בשמירת הנתונים", }, "error", 3000);
    }
  };


  ValidatePhones = (e) => {

    // Function to count occurrences without using reduce
    const countOccurrences = (arr, val) => {
      let count = 0;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === val) {
          count++;
        }
      }
      return count;
    };

    // if appears more than 1, return false
    return countOccurrences(this.state.phonesNumbers, e.value) > 1 ? false : true;
  };


  //**************************//
  //Validate if the file size is not bigger than 4MB
  ValidateImg = (e, validateStr) => {
    // validateStr="img|{Max size in MB}"
    // ex: "img|6"
    var maxSizeMB = 4;
    if (validateStr.includes("|"))
      maxSizeMB = parseInt(validateStr.split("|")[1]);

    if (e.value.length > 0) {
      var file = e.value;
      var size = file[0].size;         //size of current file

      const maxFileSize = maxSizeMB * 1024 * 1024; // 4 MB in bytes
      if (size > maxFileSize)
        return false;
    }
    return true;
  };

  //**************************//
  //Validate if the file size is not bigger than 4MB
  //  ValidateImg = (e) => {

  //   if (e.value.length > 0) {
  //     var file = e.value;
  //     var size = file[0].size;         //size of current file

  //     const maxFileSize = 4096 * 1024; // 4 MB in bytes
  //     if (size > maxFileSize)
  //       return false;
  //   }
  //   return true;
  // };


  ValidateID = (e) => {
    // DEFINE RETURN VALUES
    var R_ELEGAL_INPUT = false;
    var R_NOT_VALID = false;
    var R_VALID = true;
    var str = e.value;
    //INPUT VALIDATION

    // Just in case -> convert to string
    var IDnum = String(str);

    // Validate correct input
    if (IDnum.length > 9 || IDnum.length < 5) return R_ELEGAL_INPUT;
    if (isNaN(IDnum)) return R_ELEGAL_INPUT;

    // The number is too short - add leading 0000
    if (IDnum.length < 9) {
      while (IDnum.length < 9) {
        IDnum = "0" + IDnum;
      }
    }

    // CHECK THE ID NUMBER
    var mone = 0,
      incNum;
    for (var i = 0; i < 9; i++) {
      incNum = Number(IDnum.charAt(i));
      incNum *= (i % 2) + 1;
      if (incNum > 9) incNum -= 9;
      mone += incNum;
    }
    if (mone % 10 == 0) return R_VALID;
    else return R_NOT_VALID;
  };

  //GENEREATS THE VALIDATION ARRAY FOR THE GETFIELD FUNCTION ON RUNTIME
  getValidation = (dataField, title) => {
    let validationArray = [];
    if (dataField.validation.includes("email"))
      validationArray.push({
        type: "email",
        message: "יש להזין אי מייל תקין" + ` (${title})`,
      });

    if (dataField.validation.includes("numeric"))
      validationArray.push({
        type: "numeric",
        message: "יש להזין מספרים בלבד" + ` (${title})`,
      });

    if (dataField.validation.includes("range"))
      validationArray.push({
        type: "range",
        message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
      });

    if (dataField.validation.includes("stringLength")) {
      const validationObj = {
        type: "stringLength",
        message: dataField.validationMessage + ` (${title})`,
      };

      if (dataField.minValue === null || dataField.minValue === "" || dataField.minValue === " " || dataField.minValue === undefined) {
        validationObj.min = 0;
      } else {
        validationObj.min = dataField.minValue;
      }

      if (dataField.maxValue === null || dataField.maxValue === "" || dataField.maxValue === " " || dataField.maxValue === undefined) {
        validationObj.max = 1000000;
      } else {
        validationObj.max = dataField.maxValue;
      }

      validationArray.push(validationObj);
    }



    if (dataField.validation.includes("phone"))
      validationArray.push({
        type: "custom",
        validationCallback: (e) => {
          // Allow empty values when skipRequired is true
          if (this.doc?.skipRequired && (!e.value || e.value.trim() === '')) {
            return true;
          }
          return this.ValidatePhones(e);
        },
        message:
          "אין לעשות שימוש חוזר במספר טלפון שכבר הוקלד בטופס" + ` (${title})`,
      });

    if (dataField.validation.includes("id"))
      validationArray.push({
        type: "custom",
        validationCallback: (e) => {
          // Allow empty values when skipRequired is true
          if (this.doc?.skipRequired && (!e.value || e.value.trim() === '')) {
            return true;
          }
          return this.ValidateID(e);
        },
        message: " יש להזין ת.ז תקין" + ` (${title})`,
      });

    if (dataField.validation.includes("compare"))
      validationArray.push({
        type: "compare",
        message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
      });

    if (dataField.validation.includes("pattern"))
      validationArray.push({
        type: "pattern",
        pattern: dataField.validationPatameters,
        message: dataField.validationMessage + ` (${title})`,
      });

    // if (dataField.validation.includes("img"))
    //   validationArray.push({
    //     type: "required",
    //     message: dataField.validationMessage + ` (${title})`,
    //   });

    //*****************************//
    if (dataField.validation.includes("img")) {

      validationArray.push({
        type: "custom",
        validationCallback: (e) => {
          // Allow empty values when skipRequired is true
          if (this.doc?.skipRequired && (!e.value || e.value.length === 0)) {
            return true;
          }
          var flag = this.ValidateImg(e, dataField.validation)
          return flag
        },
        //   validationCallback: this.ValidateImg,
        message: "הקובץ שהעלית חורג מהגודל המבוקש" + ` (${title})`,
      });
    }

    if (dataField.validation.includes("multipleEmails")) {
      validationArray.push({
        type: "custom",
        validationCallback: (e) => {
          // Allow empty values when skipRequired is true
          if (this.doc?.skipRequired && (!e.value || e.value.trim() === '')) {
            return true;
          }
          var flag = this.ValidateEmails(e.value);
          return flag;
        },
        message: dataField.validationMessage + ` (${title})`,
      });
    }

    //*****************************//

    // Check if required validation should be applied
    // Skip if this.setting.skipRequired is true
    const shouldSkipRequired = this.doc?.skipRequired ?? false;
    if (this.visibleFunction(dataField.required) && !shouldSkipRequired) {

      validationArray.push({
        type: "required",
        message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
      });
    }

    return validationArray;
  };

  // Add this method to your class or module
  ValidateEmails(emailString) {
    // Define a simple regular expression for validating email
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Split the email string by commas and trim each email
    const emails = emailString.split(',').map(email => email.trim());
    // Check each email against the pattern
    for (let email of emails) {
      if (!emailPattern.test(email)) {
        return false;
      }
    }
    return true;
  }


  handleUploadFile = (e) => {
    this.setState({
      ownersNames: "",
      phonesNumbers: [],
      sendApendixPopupVisible: false,
    });

    const file = e.value[0];
    var fileName = file.name;

    // Handle .txt.json extension
    if (fileName.endsWith('.txt.json')) {
      fileName = fileName.replace('.json', ''); // Remove the .json part
    }


    if (fileName.endsWith('.txt') || fileName.endsWith('.encrypt')) {
      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      try {
        fileReader.onload = (e) => {
          const data = fileName.includes("encrypted") ? encryptionKey.decrypt(fileReader.result) : e.target.result;
          let filteredData = JSON.parse(data);
          Object.keys(filteredData).forEach(function (key) {
            if (key.includes("fileUploader")) {
              delete filteredData[key];
            }
          });
          if (data === false) {
            notify("טעינת הקובץ נכשלה, יש לוודא שמדובר בקובץ שמתאים לטופס", "error", 10000);
          } else {
            this.doc = filteredData;
            this.executeFunctionByUid("RunAfterLoad");
            this.doc.owner.map((item) =>
              this.setState({
                ownersNames: (this.state.ownersNames += `${item.firstName} ${item.lastName}  `),
              })
            );
          }
          this.updatePhones();
        };
      } catch (error) {
        notify("משהו השתבש.. נסה שנית", "error", 3000);
      }
    } else if (fileName.endsWith('.xlsx')) {
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file);
      fileReader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        // Assuming jsonData is an array of objects representing the rows in the XLSX file
        // You can process jsonData further as needed
        let filteredData = unflattenObject(jsonData[0]);
        this.doc = filteredData;
        this.doc.owner.map((item) =>
          this.setState({
            ownersNames: (this.state.ownersNames += `${item.firstName} ${item.lastName}  `),
          })
        );
        this.updatePhones();
        this.executeFunctionByUid("OnFileLoaded");

      };
    } else {
      notify("Unsupported file format. Please upload a TXT, ENCRYPT, or XLSX file.", "error", 5000);
    }
  };


  clearUnvisibleData = () => {
    this.template.tabs.map((tab) => {
      // run on all tabs
      const tabName = tab.Value.split("|")[0]; // get the tab name
      // check if the tab is an array or single
      if (tab.Type === "array") {
        for (let i = 0; i < this.doc[tabName].length; i++) {
          for (const [key, value] of Object.entries(this.template[tabName])) {
            this.clearField(value, tabName + "[" + i + "]." + value._uid, i);
          }
        }
      } else {
        // if tab is not array
        for (const [key, value] of Object.entries(this.template[tabName])) {
          this.clearField(value, tabName + "." + value._uid, "");
        }
      }
    });
  };

  clearField = (dataForField, key, index) => {
    const fieldVisible = dataForField.visible
      ? this.visibleFunction(
        dataForField.visible.replaceAll("[x]", "[" + index + "]")
      )
      : this.visibleFunction(dataForField.visible);
    if (!fieldVisible) {
      try {
        eval("this.doc." + key + " = null");
      } catch { }
    }
  };
  addOwner = (v) => {
    this.doc[v].push({});
    this.updatePhones();
  };
  deleteOwner = (e) => {
    const page = e?.fields[0].object;
    let s = this.doc[page].splice(e?.index, 1);
    this.updatePhones();
  };
  addAccount = (e) => {
    this.doc.account.push({});
    this.updatePhones();
  };


  countVisibleTabs = (tabs) => {
    const visibleTabs = [];
    tabs?.map((item) => {
      if (this.visibleFunction(item.visible) === true) {
        visibleTabs.push(item);
      }
    })
    return visibleTabs.length;
  }

  renderItem(data) {
    const inputAttr = { accept: ".json, .txt, .xlsx" };
    return (
      <FileUploader
        multiple={false}
        selectButtonText={"טען קובץ"}
        labelText=""
        accept="json/*.json/.txt/.xlsx"
        onValueChanged={this.handleUploadFile}
        onFilesUploaded={this.resetState}
        inputAttr={inputAttr}
        hint="ניתן להעלות רק קבצי טקסט מוצפנים שנשמרו מהמערכת." // Tooltip message
        visible={true}
      />
    );
  }

  getItemArray(obj) {
    let dataItems = obj.split("|");
    dataItems = dataItems.map((item) => item.split(":"));
    const values = [];
    dataItems.forEach((element) => {
      values.push({
        id: element[0],
        name: element[1],
      });
    });
    return values;
  }

  handleSubmit(e) {
    e.preventDefault();
    var form = this.formElement.current; //retrieve the form as a DOM element
    var input = document.createElement("input"); //prepare a new input DOM element
    input.setAttribute("name", "jsonValues"); //set the param name
    input.setAttribute("value", JSON.stringify(this.doc)); //set the value
    input.setAttribute("type", "hidden"); //set the type, like "hidden" or other

    form.appendChild(input);

  }

  executeFunctionByUid(uid) {
    try {

      if (this.template.Run !== undefined) {
        const runBeforeSend = this.template.Run.find(item => item._uid === uid);
        if (runBeforeSend !== undefined) {
          this.execFunction(runBeforeSend.onChangeValue);
        }
      }
    } catch (error) {
      console.error('Error in executeFunctionByUid:', error);
    }
  };


  // Iterates over an array of objects and executes onChangeValue if it is defined and a function.
  ExecuteMultipleFunctions(object) {
    // Validate that object is an array
    if (!Array.isArray(object)) {
      return;
    }
    object.map((item) => {
      // Validate that onChangeValue is defined before executing the function
      if (item.onChangeValue !== undefined) {
        this.execFunction(item.onChangeValue);

      }
    });
  }


  // Splits funcStr by commas, finds corresponding functions in the template, and executes them if valid.
  runFunction(funcStr) {
    if (!funcStr) return;

    const functions = funcStr.split(",");
    if (functions.length === 0) return;

    for (const func of functions) {
      const funToRun = this.template.Func.find(item => item._uid === func);
      if (funToRun !== undefined) {
        const ans = this.execFunction(funToRun.onChangeValue);
        return ans;
      }
    }
    return undefined; // explicitly return if nothing matched
  }

  validateAndNotify() {
    let isValidationTriggered = false;
    const validations = this.template?.Validation || [];

    const messages = validations
      .filter(({ Value: condition, validationMessage: message }) => condition && message && this.execFunction(condition))
      .map(({ validationMessage: message }) => message);

    if (messages.length > 0) {
      isValidationTriggered = true;
      messages.forEach((message, index) => {
        setTimeout(() => {
          notify(message, "error", 3000);
        }, index * 3000); // Delay each message by 3 seconds
      });
    }

    return isValidationTriggered;
  }


  sendForm(e) {
    //const dataFromLS = JSON.parse(localStorage.getItem("user"));
    const res = e.validationGroup.validate();

    if (res.status === "valid") {

      //validate before send
      const validationTriggered = this.validateAndNotify();
      if (validationTriggered) {
        return
      }

      this.clearUnvisibleData(); //clear unvisible data
      this.executeFunctionByUid("RunBeforeSend");

      // multiple RunBeforeSend
      if (this.template.RunBeforeSend !== undefined) {
        this.ExecuteMultipleFunctions(this.template.RunBeforeSend);
      }

      //all requierd fields are valid
      this.doc.apendix.marketer =
        this.state.user.firstName + " " + this.state.user.lastName;

      //this.doc.apendix.date = new Date().toLocaleDateString();
      var form = this.formElement.current; //retrieve the form as a DOM element

      const encryptedJson = encryptionKey.encrypt(JSON.stringify(this.doc)); //returns encrypted string

      var sendInput = {
        flatValues: flatObject(this.doc),
        document: this.doc,
        user: this.createUser(),
        formId: this.state.dataFromDB.ID,
        XLClient: this.state.XLClient,
        XLAccount: this.state.XLAccount,
        jsonFile: encryptedJson,
        sourceTaskId: this.getParameterFromUrl("t"),
        sendingType: this.state.sendingType,
        formVersion: "test-form",
        draftPayload: this.doc.chosenAgentId != null ? this.buildDraftPayload() : null,
        chosenAgentId: this.doc.chosenAgentId,
      };
      this.downloadFile(this.doc);

      //this.onSaveFile(e);
      var input = document.createElement("input"); //prepare a new input DOM element
      input.setAttribute("name", "jsonValues"); //set the param name
      input.setAttribute("value", JSON.stringify(sendInput)); //set the value
      input.setAttribute("type", "hidden"); //set the type, like "hidden" or other

      form.appendChild(input);
      const data = new FormData(form);
      this.setState({ isFirsTimeLoaded: false, isLoading: true });
      this.PostFormToDB(data, this.doc.files.toReference);
    } else {
      // const msg = "אופס... יש כמה שדות חסרים";
      const msg = "אופס... חלה שגיאה בפרטים שמילאת"
      notify(msg, "error", 3000);
    }
  }

  //load template from api -//todo: make the url dynamic according to data from log in + selection
  fetchTemplate = async (data, fid = null) => {
    const url = data.UrlToApi
    fid = fid ?? this.state.formId;

    //create group by objects name
    const handleValues = async (data) => {
      this.template = data;

      // Load DataSets from all fields
      const allFields = Object.values(data).flat().filter(f => f && f.Type);
      const dataSetFields = allFields.filter(f => f.Type === 'DataSet');
      if (dataSetFields.length > 0) {
        try {
          await DataSetManager.loadAllDataSets(dataSetFields);
        } catch (err) {
          console.error('Failed to load DataSets:', err);
        }
      }

      this.setState({
        isFirsTimeLoaded: true,
        dataSetsLoaded: true,
        XLClient: data.XLClient?.[0]?.Value,
        XLAccount: data.XLAccount?.[0]?.Value,
        numOfVisibleTabs: this.countVisibleTabs(data.tabs),
      });
      this.interval();
      this.executeFunctionByUid("OnTemplateLoading");
    };
    const raw = localStorage.getItem(`form_${fid}`);

    try {
      if (!raw) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Network response was not ok");

        const values = await response.json();
        const grouped = groupBy3(values, "object");
        const encrypted = EncryptionUtil.obfuscate(grouped);

        localStorage.setItem(`form_${fid}`, encrypted);
        handleValues(grouped);
      } else {
        const values = EncryptionUtil.deobfuscate(raw);
        handleValues(values);
      }
    } catch (error) {
      console.error("Failed to fetch or process template:", error);
      notify(
        {
          message: "אירעה שגיאה בעת טעינת הנתונים.",
        },
        "error",
        4000
      );
    }
  };

  GetDataFromDB = (fid = null) => {
    let urlParameterU = this.getParameterFromUrl("u");
    let urlParameterF = undefined;
    let formNickName = this.getParameterFromUrl("fn");

    if (urlParameterU === undefined) {
      urlParameterF = this.getParameterFromUrl("f");
    } else if (urlParameterF === undefined) {
      if (formNickName !== undefined) {
        // urlParameterF =  fetchListIDFromNickName(formNickName, this.props.userData);
      }

    }

    const data = this.props.userData.data.form.listOfForms.find((f) => {
      if (urlParameterU !== undefined) {
        return f.UrlToApi.substring(35) === urlParameterU;
      } else if (urlParameterF != undefined) {
        // Adjusted comparison when urlParameterU is undefined
        return f.ID == urlParameterF; // Assuming f.ID is the correct property to compare with urlParameterF
      } else if (formNickName !== undefined) {
        return f.NickName === formNickName;
      }
      return false; // Default case if neither urlParameterU nor urlParameterF is defined
    });
    this.settings.agentId = this.props.userData.data.user.agentId
    this.settings.roles = this.props.userData.data.user.roles
    this.settings.isLicense = this.settings.roles.includes("License")
    this.setState({ dataFromDB: data, user: this.props.userData.data.user });
    this.fetchTemplate(data, fid);
  };


  async PostFormToDB(data, isDraft) {
    const response = await fetch(`${REACT_APP_SERVER_URL}docfile`, {
      method: "POST",
      body: data,
      credentials: "include",
    });
    if (response.ok) {
      if (isDraft) {
        notify(
          {
            message: "הפרטים שמילאת נשמרו והמסמך עבר להמשך מילוי",
          },
          "success",
          3000
        );

        this.props.history.push({
          pathname: "./home",
        });
        return;
      }

      response
        .json()
        .then((response) => {
          this.props.history.push({
            pathname: "./signatures",
            search: `?i=${response}`,
          }); //move to signaturesPage with id
        })
        .catch(
          (error) => { } // Handle the error response object
        );
    } else {
      const errorResponse = await response.json();
      if (errorResponse.Message === "המסמך לא אושר לשליחה חוזרת")
        notify(errorResponse.Message, "error", 8000);
      else {
        this.validateConnection();
        notify("משהו השתבש .. נסה שנית", "error", 3000);
      }
      this.setState({ isLoading: false });
    }
  }
}
export default App;